module.exports = __webpack_public_path__ + "img/logo.093bd3b9.png";